// Las acciones async thunk ya manejan el flujo automáticamente,
// pero si necesitamos lógica adicional podemos agregarla aquí
// Por ahora, este saga está vacío ya que createAsyncThunk maneja todo
export function* invoicesSaga() {
  // Las acciones async de invoices-slice se manejan automáticamente
  // No necesitamos lógica adicional aquí por ahora
}
